"use strict";

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var defaultHolePunchCharge = 10;

module.exports = function (accumulator, order, product, component, options) {
  var addition = parseBoolean(component.hole_punch) ? options.holePunchCharge || defaultHolePunchCharge : 0;
  return (parseFloat(accumulator, 10) || 0) + addition;
};